<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-11">
          <strong class="card-title mb-3">{{(id !== '')? 'Edit' : 'Add'}} Blog</strong>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div>
        <div class="mb5"></div>
        <!-- <vform :formData="editForm" :fields="fields" :submitCallback="showSmallModal"/> -->
        <form class="form-horizontal" @onsubmit.prevent action>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group" :class="{'has-error': validation.hasError('auther')}">
                <label class="form-control-label">Blog Auther</label>
                <input
                  type="text"
                  class="form-control inmarginbtm"
                  placeholder="Auther"
                  value
                  v-model="auther"
                />
                <div class="error">{{ validation.firstError('auther') }}</div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group" :class="{'has-error': validation.hasError('name')}">
                <label class="form-control-label">Blog Title</label>
                <input
                  type="text"
                  class="form-control inmarginbtm"
                  placeholder="Title"
                  value
                  v-model="name"
                />
                <div class="error">{{ validation.firstError('name') }}</div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group" :class="{'has-error': validation.hasError('description')}">
                <label class="form-control-label">Description</label>
                <!-- <textarea
                  class="form-control inmarginbtm"
                  placeholder="Description"
                  value
                  v-model="description"
                ></textarea>-->
                <vue-ckeditor id="description" v-model="description" :config="config" />
                <div class="error">{{ validation.firstError('description') }}</div>
              </div>
            </div>
            <div class="col-md-12">
              <div
                class="form-group"
                :class="{'has-error': validation.hasError('long_description')}"
              >
                <label class="form-control-label">Long Description</label>
                <!-- <textarea
                  class="form-control inmarginbtm"
                  placeholder="Long Description"
                  value
                  v-model="long_description"
                ></textarea>-->
                <vue-ckeditor id="long_description" v-model="long_description" :config="config" />
                <div class="error">{{ validation.firstError('long_description') }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" :class="{'has-error': validation.hasError('sortOrder')}">
                <label for="sort-order" class="form-control-label">Sort Order</label>
                <input class="form-control" type="number" v-model="sortOrder" />
                <div class="error">{{ validation.firstError('sortOrder') }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" :class="{'has-error': validation.hasError('status')}">
                <label for="select-status" class="form-control-label">Status</label>
                <select id="select-status" class="form-control" v-model="status">
                  <option value>Select Status</option>
                  <option
                    v-for="(f, index) in userStatus"
                    :value="f.id"
                    :key="index+f.value"
                  >{{f.value}}</option>
                </select>
                <div class="error">{{ validation.firstError('status') }}</div>
              </div>
            </div>
            <div class="col-md-10"></div>
            <div class="col-md-1 pull-right">
              <div class="form-group">
                <button type="button" @click="addBlog" class="btn btn-primary">Save</button>
              </div>
            </div>
            <div class="col-md-1 pull-right">
              <div class="form-group">
                <button
                  type="button"
                  @click="cancel"
                  class="btn btn-outline-primary pull-right"
                >Cancel</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
// import PinCheck from "@/components/PinCheck.vue";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Datepicker from "vuejs-datepicker";
import SimpleVueValidation from "simple-vue-validator";
var Validator = SimpleVueValidation.Validator;
import VueCkeditor from "vue-ckeditor2";

export default {
  components: { Datepicker, VueCkeditor },
  mixins: [commonMixins],
  created() {
    if (this.$route.params.id) {
      this.id = parseInt(this.$route.params.id);
      this.getblogDetails();
    } else {
    }
  },
  validators: {
    auther: function(value) {
      return Validator.value(value).required();
    },
    name: function(value) {
      return Validator.value(value).required();
    },
    description: function(value) {
      return Validator.value(value).required();
    },
    long_description: function(value) {
      return Validator.value(value).required();
    },
    status: function(value) {
      return Validator.value(value).required();
    },
    sortOrder: function(value) {
      return Validator.value(value).required();
    }
  },
  data() {
    return {
      blogDetails: {},
      id: "",
      auther: "",
      name: "",
      description: "",
      long_description: "",
      sortOrder: 0,
      status: 1,
      userStatus: [{ id: 0, value: "Inactive" }, { id: 1, value: "Active" }],
      config: {
        toolbar: [
          {
            name: "snddocument",
            items: [
              "Source",
              "-",
              "Save",
              "NewPage",
              "DocProps",
              "Preview",
              "Print",
              "-",
              "Templates"
            ]
          },
          { name: "clipboard", items: ["Undo", "Redo"] },
          {
            name: "editing",
            items: [
              "Find",
              "Replace",
              "-",
              "SelectAll",
              "-",
              "SpellChecker",
              "Scayt"
            ]
          },
          {
            name: "forms",
            items: [
              "Form",
              "Checkbox",
              "Radio",
              "TextField",
              "Textarea",
              "Select",
              "Button",
              "ImageButton",
              "HiddenField"
            ]
          },
          "/",
          {
            name: "basicstyles",
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "Subscript",
              "Superscript",
              "-",
              "RemoveFormat"
            ]
          },
          {
            name: "paragraph",
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote",
              "CreateDiv",
              "-",
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock",
              "-",
              "BidiLtr",
              "BidiRtl"
            ]
          },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
          {
            name: "insert",
            items: [
              "Image",
              // "Flash",
              "Table",
              "HorizontalRule",
              "Smiley",
              "SpecialChar",
              "PageBreak",
              "Iframe"
            ]
          },
          { name: "styles", items: ["Styles", "Format", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "tools", items: ["Maximize", "ShowBlocks"] }
        ]
      }
    };
  },
  methods: {
    addBlog() {
      console.log('Add');
      var _this = this;
      this.submitted = true;
      this.$validate().then(success => {
        console.log('on success ' + success)
        if (success) {
          const data = {
            id: _this.id,
            auther: _this.auther,
            name: _this.name,
            description: _this.description,
            longDescription: _this.long_description,
            sortOrder: _this.sortOrder,
            status: _this.status,
          };
          console.log("Submit data", data);
          http.post("blog/add", data, (error, response) => {
            if (response.ok === 1) {
              _this.$toastr.success("Blog saved successfully!", {});
              _this.$router.push({ name: "blogs" });
            } else {
              _this.$toastr.error(
                "Oops, Something went wrong! Please try again later.",
                {}
              );
            }
          });
        }
      });
    },
    clearForm() {
      this.blogDetails = {};
      (this.name = ""),
        (this.description = ""),
        (this.long_description = ""),
        (this.status = 1),
        (this.sortOrder = 0),
        (this.companies = "");
    },
    updateBlog() {},
    getblogDetails() {
      var _this = this;
      http.post("blog/get/1", { id: _this.id }, (error, response) => {
        if (response.data && response.data.length) {
          _this.blogDetails = response.data[0];
          _this.auther = _this.blogDetails.auther;
          _this.name = _this.blogDetails.name;
          _this.description = _this.blogDetails.description;
          _this.long_description = _this.blogDetails.longDescription;
          _this.sortOrder = _this.blogDetails.sortOrder;
          _this.status = _this.blogDetails.status;
          _this.companies = _this.blogDetails.companies;
          _this.selComps = _this.blogDetails.companies;
        } else {
          this.$toastr.error("Oops, something went wrong!");
          this.$router.push({
            name: "blogs"
          });
        }
      });
    },
    cancel() {
      this.$router.push({
        name: "blogs"
      });
    },
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.clear-fix {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/blog/add-blog.vue